// popper.js bundle containing all modifiers needed to render the tooltips
// properly

import arrowModifier from "@popperjs/core/lib/modifiers/arrow";
import offsetModifier from "@popperjs/core/lib/modifiers/offset";
import preventOverflowModifier from "@popperjs/core/lib/modifiers/preventOverflow";
import {
  popperGenerator,
  defaultModifiers,
} from "@popperjs/core/lib/popper-lite";

export const createPopper = popperGenerator({
  defaultModifiers: [
    ...defaultModifiers,
    arrowModifier,
    offsetModifier,
    preventOverflowModifier,
  ],
});
